"use strict";

exports.__esModule = true;
exports.downloadData = void 0;
var downloadData = exports.downloadData = function downloadData(data, filename, extension) {
  var link = document.createElement("a");
  var objectURL = URL.createObjectURL(new Blob([data], {
    type: "text/plain;encoding:utf-8"
  }));
  link.setAttribute("href", objectURL);
  link.setAttribute("download", filename + "." + extension);
  link.click();
  URL.revokeObjectURL(objectURL);
};